import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { TileContainer } from "./styles";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { Button, FileUploader } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import HeadingContainer from "../../../layout/heading-container";

const UploadStatement = (props: DestinationAccountControllerType) => {
  const {
    onClickContinue,
    currentDestinationDetails,
    onClickSkipStatement,
    uploadedFiles,
    formValidation,
    handleUploadFile,
    isUploading,
    handleRemoveFile,
  } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-destination-account">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Upload a recent statement from your current account</TitleLarge>
            <BodyLargeRegular>
              To find your statement, log into your provider portal (e.g., Fidelity, TIAA), type “Statement” into the
              search bar, and download your most recent statement.
            </BodyLargeRegular>
          </HeadingContainer>
          <TileContainer $flexDirection="column" $width="100%">
            <FileUploader
              files={uploadedFiles}
              maxFiles={3}
              hasMultiple={false}
              onUploadFile={handleUploadFile}
              onFileRemove={handleRemoveFile}
              accept={{
                "application/pdf": [".pdf"],
                "image/jpeg": [".jpeg"],
                "image/jpg": [".jpg"],
                "image/png": [".png"],
                "image/heic": [".heic"],
                "image/heif": [".heif"],
              }}
              supportingText="Files must be less than 10MB. File types: 
.pdf, .jpeg, .jpg, .png, .heic."
              error={formValidation.destinationStatementFileNames}
            />
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large" isLoading={isUploading}>
          Continue
        </Button>
        {currentDestinationDetails.destinationStatementFileNames.length === 0 && (
          <Button name="skipStatement" onClick={onClickSkipStatement} variant="text" className="secondary-cta">
            No statement found
          </Button>
        )}
      </Footer>
    </TransitionWrapper>
  );
};

export default UploadStatement;
